import { Button } from 'seagull';
import { Intent } from "../../infra/access-control";
import { fullName } from "../../infra/utils";
import { relationshipModel } from "../../models";
import { selectors } from "../../store/state-selectors";
import { useStore } from "../../store/store-context";
import { MobileSign } from "../clientOb/components/MobileSign";
import Signature from "../clientOb/components/Signature";
import styles from "./AcceptProposalButton.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ApproveProposalButton = _ref => {
  let {
    testId,
    disabled,
    isDesktop,
    relationship,
    previewStatus,
    onDone
  } = _ref;
  const userFirstName = useStore(selectors.user.firstName) || null;
  const userLastName = useStore(selectors.user.lastName) || null;
  return previewStatus && previewStatus.inModal ? /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsx(Signature, {
      className: styles.signature,
      children: relationshipModel.buyerFullName(relationship)
    }), /*#__PURE__*/_jsx(Button, {
      onClick: previewStatus.onDismissPreviewModal,
      fluid: true,
      testId: "preview-dismiss-modal",
      children: "Click to approve agreement"
    })]
  }) : isDesktop ? /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [disabled || /*#__PURE__*/_jsx(Signature, {
      className: styles.signature,
      children: fullName(userFirstName, userLastName)
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onDone,
      fluid: true,
      intent: Intent.ApproveProposal,
      disabled: disabled,
      testId: testId,
      children: "Click to approve agreement"
    })]
  }) : /*#__PURE__*/_jsx(MobileSign, {
    intent: Intent.ApproveProposal,
    relationship: relationship,
    disabled: disabled,
    onSign: () => onDone()
  });
};
export default ApproveProposalButton;